import React from "react"

export const SmallToolbarContext = React.createContext(["", () => {}])